import { ServerFetch } from '../main-model'

export default class StockPackListModel extends ServerFetch {
    getStockPackListBy = (data) => this.authFetch({
        url: 'stock-pack-list/getStockPackListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}